import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

export default ({ app }) => {
  const echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.PUSHER_APP_KEY,
    cluster: process.env.PUSHER_APP_CLUSTER,
    encrypted: true,
    // Add any other options you need
  });

  app.echo = echo;
  // Make the echo instance available globally in your components using `this.$echo`
};
